/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @legacy
 * @alpha
 */
export var ContainerMessageType;
(function (ContainerMessageType) {
    // An op to be delivered to store
    ContainerMessageType["FluidDataStoreOp"] = "component";
    // Creates a new store
    ContainerMessageType["Attach"] = "attach";
    // Chunked operation.
    ContainerMessageType["ChunkedOp"] = "chunkedOp";
    // Signifies that a blob has been attached and should not be garbage collected by storage
    ContainerMessageType["BlobAttach"] = "blobAttach";
    // Ties our new clientId to our old one on reconnect
    ContainerMessageType["Rejoin"] = "rejoin";
    // Sets the alias of a root data store
    ContainerMessageType["Alias"] = "alias";
    /**
     * An op containing an IdRange of Ids allocated using the runtime's IdCompressor since
     * the last allocation op was sent.
     * See the [IdCompressor README](./id-compressor/README.md) for more details.
     */
    ContainerMessageType["IdAllocation"] = "idAllocation";
    /**
     * An op that changes document schema
     */
    ContainerMessageType["DocumentSchemaChange"] = "schema";
    /**
     * Garbage collection specific op. This is sent by the summarizer client when GC runs. It's used to synchronize GC
     * state across all clients.
     */
    ContainerMessageType["GC"] = "GC";
})(ContainerMessageType || (ContainerMessageType = {}));
//# sourceMappingURL=messageTypes.js.map